import React, { Component } from 'react';
import StreamPlayer from '../Stream/StreamPlayer/StreamPlayer';
import StreamDescriptionModal from '../Stream/StreamDescriptionModal/StreamDescriptionModal';
import StreamArtistsModal from '../Stream/StreamArtistsModal/StreamArtistsModal';
import PropTypes from "prop-types";
import coverTheater from '../../images/cover-theater.jpg';
import { ApiRequest, generateUuidv4 } from "../../helpers";

class StreamDemo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            viewerId: null,
            activationCode: 'CDMVM1',
            fetchedVideoInfos: false,
            eventExists: false,
            activeEvent: {},
            streamConfig: {}
        }
    };

    componentDidMount() {
        const viewerId = generateUuidv4();
        this.setState({
            viewerId
        }, () => {
            this.getVideoInfos();
        });
    }

    getVideoInfos = async () => {
        try {
            const streamResponse = await this.fetchStreamInfos();
            console.log('streamResponse: ', streamResponse);
            this.setState({
                streamConfig: streamResponse.data
            });

            if (!streamResponse.data.error) {
                this.setState({
                    fetchedVideoInfos: true
                });
            }

            const activeEventInfoResponse = await this.getActiveEventInfo(streamResponse.data.event_id);
            console.log('active event info response: ', activeEventInfoResponse);
            if(activeEventInfoResponse.data.event){
                let response = activeEventInfoResponse.data.event;

                this.setState({
                    eventExists: true,
                    activeEvent: response
                }, () => {
                    this.props.setStreamEvent(this.state.activeEvent, this.state.streamConfig);
                    
                });
            }
        } catch (error) {
            console.log(error);
        }
    };

    getActiveEventInfo = async (eventId) => {
        return await ApiRequest(`/events/public/${eventId}`, {
            method: 'GET'
        });
    };

    fetchStreamInfos = async () => {
        return await ApiRequest(`/stream/access`, {
            method: 'POST',
            data: {
                activation_code: this.state.activationCode,
                viewer_id: this.state.viewerId
            }
        });
    };

    render() {
        return (
            <React.Fragment>
                <div className="showtix-stream">
                    <StreamDescriptionModal
                        isStreamDescriptionModalOpen={this.props.isStreamDescriptionModalOpen}
                        toggleStreamDescriptionModal={this.props.toggleStreamDescriptionModal}
                        activeEvent={this.state.activeEvent}
                    />
                    <StreamArtistsModal
                        isStreamArtistsModalOpen={this.props.isStreamArtistsModalOpen}
                        toggleStreamArtistsModal={this.props.toggleStreamArtistsModal}
                        activeEvent={this.state.activeEvent}
                    />
                    <div className="showtix-section showtix-stream__wrapper" style={{backgroundImage: "url(" + coverTheater + ")"}}>
                        <div className="container showtix-stream__content">
                            <div className="row mb-4">
                                <div className="col-12 text-center">
                                    <React.Fragment>
                                    { this.state.fetchedVideoInfos &&
                                        <StreamPlayer
                                            streamConfig={this.state.streamConfig}
                                        ></StreamPlayer>
                                    }
                                    </React.Fragment>
                                </div>
                            </div>
                        </div>
                    </div>
                    <style dangerouslySetInnerHTML={{__html: `
                        .stream-player-initialized .zopim {
                            display: none !important;
                        }
                    `}} />
                </div>
            </React.Fragment>
        );
    }
}

StreamDemo.propTypes = {
    setStreamEvent: PropTypes.func,
    isStreamDescriptionModalOpen: PropTypes.bool,
    toggleStreamDescriptionModal: PropTypes.func,
    isStreamArtistsModalOpen: PropTypes.bool,
    toggleStreamArtistsModal: PropTypes.func,
};

export default StreamDemo;


// WEBPACK FOOTER //
// ./src/components/StreamDemo/StreamDemo.js